import type { RefObject } from 'react';
import { Eye } from 'config/buddy/utils';
import { BUDDY_TOKENS, CORE_R, HALO_R } from 'config/buddy/constants';

type BuddySvgProps = {
  svgRef: RefObject<SVGSVGElement>;
  lookLRef: RefObject<SVGGElement>;
  lookRRef: RefObject<SVGGElement>;
  haloId: string;
  face: { left: string; right: string };
  startedAt: number;
};

/** Buddy's face: halo, body and two eyes. Buddy moves the eyes through `lookLRef` / `lookRRef`. */
export default function BuddySvg({ svgRef, lookLRef, lookRRef, haloId, face, startedAt }: Readonly<BuddySvgProps>) {
  return (
    <svg
      ref={svgRef}
      className="klax-buddy__svg block h-full w-full origin-center cursor-grab touch-none overflow-visible"
      viewBox="0 0 200 200"
      aria-hidden="true"
      focusable="false"
    >
      <defs>
        {/* Decorative bloom behind the body. The body itself is a solid,
            fully opaque disc — Buddy never reads as see-through. */}
        <radialGradient id={haloId} cx="50%" cy="50%" r="50%">
          <stop offset="0%" stopColor={BUDDY_TOKENS.accent} stopOpacity="0.55" />
          <stop offset="60%" stopColor={BUDDY_TOKENS.accent} stopOpacity="0.32" />
          <stop offset="100%" stopColor={BUDDY_TOKENS.accent} stopOpacity="0" />
        </radialGradient>
      </defs>
      <g className="klax-buddy__halo" style={{ animationDelay: `${-(startedAt % 3200)}ms` }}>
        <circle cx="100" cy="100" r={HALO_R} fill={`url(#${haloId})`} />
      </g>
      <circle cx="100" cy="100" r={CORE_R} fill={BUDDY_TOKENS.accent} />
      <g className="klax-buddy__eyes">
        <g className="klax-buddy__eye" ref={lookLRef}>
          <Eye kind={face.left} side="left" />
        </g>
        <g className="klax-buddy__eye" ref={lookRRef}>
          <Eye kind={face.right} side="right" />
        </g>
      </g>
    </svg>
  );
}
